import { apiSlice } from '../apiSlice';

import { SuccessResponse, Paginated } from '../DTO/common.interface';
import {
	TopSeriesFilter,
	TopSeriesListDTO,
} from '../DTO/exercise/topSeries.interface';

export const topSeriesApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getTopSeriesList: builder.query<
			SuccessResponse<Paginated<TopSeriesListDTO>>,
			TopSeriesFilter
		>({
			query: (body) => ({
				url: `/web/exercise/series/top/page`,
				method: 'POST',
				body,
			}),
			providesTags: ['TopSeries'],
		}),
		getTopSeriesDetailList: builder.query<
			SuccessResponse<Paginated<TopSeriesListDTO>>,
			TopSeriesFilter
		>({
			query: (body) => ({
				url: `/web/exercise/series/top/series-page`,
				method: 'POST',
				body,
			}),
		}),

		setTop: builder.mutation<SuccessResponse<any>, string[]>({
			query: (body) => ({
				url: `/web/exercise/series/top`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['TopSeries'],
		}),

		sortTop: builder.mutation<SuccessResponse<any>, string[]>({
			query: (body) => ({
				url: `/web/exercise/series/top/sort`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['TopSeries'],
		}),
	}),
});

export const {
	useGetTopSeriesListQuery,
	useGetTopSeriesDetailListQuery,
	useSetTopMutation,
	useSortTopMutation,
} = topSeriesApiSlice;
